import { UniqueIdentifier, useDndContext } from '@dnd-kit/core';
import { DnDOverlay } from '../../../dnd/DnDOverlay';
import { SentenceDnDItem } from './SentenceDnDItem';

/**
 * SentenceDraggableOverlay.
 */
export const SentenceDraggableOverlay = ({
  allQuestions,
}: {
  allQuestions: {
    value: string;
    id: UniqueIdentifier;
  }[];
}) => {
  const { active } = useDndContext();

  const activeItem = allQuestions.find((i) => i.id === active?.id);

  if (!activeItem) {
    return null;
  }

  return (
    <DnDOverlay>
      <SentenceDnDItem
        dragOverlay
        sx={{ width: 'max-content' }}
        value={activeItem.value}
      />
    </DnDOverlay>
  );
};
